import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/Footer.css";
import { GoChevronRight } from "react-icons/go";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <>
      {/* Footer Start */}

      <footer className="">
        <div className="container-fluid footer_backGroundImage ">
          <div className="row p-4">
            <div className="col-lg-2 col-md-6 col-sm-12 Logo_Footer_FirstSection">
              <img
                className="mb-5"
                src={require("../../assets/img/SH 07.png")}
                style={{ width: "250px", height: "120px", marginLeft: "-30px" }}
                alt="Scimitar Logo"
              />

              <div className="footerSocialIcons">
                <a
                  className="btn btn-link "
                  target="_blank"
                  href="https://www.facebook.com/people/Skimitar-Hindusthan-Pvt-Ltd/61571168079515/"
                  aria-label="Facebook"
                >
                  {/* <FaFacebookF /> */}
                  <img
                    className="logos_size"
                    alt=""
                    src={require("../../assets/img/facebook_logo.png")}
                  ></img>
                </a>
                <a
                  className="btn btn-link "
                  target="_blank"
                  href="https://www.youtube.com/channel/UC5G089lU0-Y9PYShdOw7oww"
                  aria-label="Youtube"
                >
                  {/* <FaTwitter /> */}
                  <img
                    className="logos_size"
                    alt=""
                    src={require("../../assets/img/youtube_logo.png")}
                  ></img>
                </a>
                <a
                  className="btn btn-link "
                  href="https://www.linkedin.com/"
                  target="_blank"
                  aria-label="LinkedIn"
                >
                  {/* <FaLinkedinIn /> */}
                  <img
                    className="logos_size"
                    alt=""
                    src={require("../../assets/img/linkedin_logo.png")}
                  ></img>
                </a>
                <a
                  className="btn btn-link "
                  target="_blank"
                  href="https://www.instagram.com/skimitarpromo/"
                  aria-label="Instagram"
                >
                  {/* <FaInstagram /> */}
                  <img
                    className="logos_size"
                    alt=""
                    src={require("../../assets/img/instagram_logo.png")}
                  ></img>
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 Logo_Footer_SecondSection product_design">
              <h5 className="text-danger">Products</h5>
              <div className="footer_socialIcons">
                <div className="row">
                  <div className="col-md-5 ">
                    <a
                      className="btn  "
                      href="/industrail-automation"
                      style={{ fontWeight: "300" }}
                    >
                      <GoChevronRight className="" />
                      Mitsubishi
                    </a>
                    <a className="btn " href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      Siemens
                    </a>
                    <a className="btn " href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      Delta
                    </a>
                    <a className="btn" href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      Omron
                    </a>
                    <a className="btn " href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      Schneider
                    </a>
                  </div>
                  <div className="col-md-5">
                    <a className="btn " href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      Xinje
                    </a>
                    <a className="btn " href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      Inovance
                    </a>
                    <a className="btn " href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      Rockwell
                    </a>
                    <a className="btn " href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      ABB
                    </a>
                    <a className="btn " href="#" style={{ fontWeight: "300" }}>
                      <GoChevronRight className="" />
                      Others
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-2 col-md-6 col-sm-12 Logo_Footer_ThirdSection"
              // style={{ marginLeft: "-50px" }}
            >
              <h5 className="text-danger">Services</h5>
              <div className="footer_socialIcons">
                <a
                  className="btn footer_menu_color "
                  href="/equipment-repair"
                  style={{ fontWeight: "300" }}
                >
                  <GoChevronRight className="mx-1" />
                  Hardware Services
                </a>
                <a
                  className="btn  footer_menu_color"
                  href="#"
                  style={{ fontWeight: "300" }}
                >
                  <GoChevronRight className="mx-1" />
                  Machine Retrofit
                </a>
                <a
                  className="btn  footer_menu_color"
                  href="#"
                  style={{ fontWeight: "300" }}
                >
                  <GoChevronRight className="mx-1" />
                  Panel Fabrication
                </a>
                <a
                  className="btn  footer_menu_color"
                  href="#"
                  style={{ fontWeight: "300" }}
                >
                  <GoChevronRight className="mx-1" />
                  Onsite & Field Services
                </a>
                <a
                  className="btn  footer_menu_color"
                  href="#"
                  style={{ fontWeight: "300" }}
                >
                  <GoChevronRight className="mx-1" />
                  Training Services
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="  Logo_Footer_FourthSection">
                <h5 className="text-danger" style={{ marginLeft: "90px" }}>
                  Branches
                </h5>
              </div>

              <div className=" Logo_Footer_FourthSection address_style">
                {/* <h5 className="text-danger">Address</h5> */}

                <div className="mb-2 footer_address_ mt-3  text-dark">
                  <FaMapMarkerAlt className="me-3" />
                  1st Floor,D.No:027,Ward 25th,2nd Cross,Annamalai Layout,Nalli Hospital Road, 
                  Erode -638011
                </div>
                <div className="mb-2 " style={{ fontWeight: "300" }}>
                  <FaPhoneAlt className="me-3" />
                  +91-824 801 0909
                </div>
                <div className="mb-2 " style={{ fontWeight: "300" }}>
                  <FaEnvelope className="me-3" />
                  info@skimitarhindusthan.com
                </div>
              </div>
            </div>
          </div>
          <hr className="text-warning "></hr>

          <div className="text-center">
            <div className="row mt-3">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <p className=" footer_address_ copyRights_Footer text-dark">
                  © Copyright 2026. All Rights Reserved by{" "}
                  <span className="text-danger">Skimitar Hindusthan</span>
                </p>
              </div>
              {/* <div className="col-lg-2 col-md-2 col-sm-12 left_right_line"></div> */}
              <div className="col-lg-6 col-md-6 col-sm-12">
                <h6 className="footer_address_ text-dark copyRights_Footer">
                  Designed By Aalan Tech Soft
                </h6>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  ); 
}

export default Footer;
